var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "table-grid-content" },
        [
          _c(
            "el-col",
            { attrs: { span: 3 } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入搜索内容" },
                model: {
                  value: _vm.selecttypeName,
                  callback: function($$v) {
                    _vm.selecttypeName = $$v
                  },
                  expression: "selecttypeName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticClass: "grid",
              staticStyle: { "margin-left": "1rem" },
              attrs: { span: 3, gutter: 1 }
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "success", icon: "el-icon-search" },
                  on: { click: _vm.selectinit }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticClass: "grid",
              staticStyle: { "margin-left": "-2rem" },
              attrs: { span: 2, gutter: 15 }
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.addParamete()
                    }
                  }
                },
                [_vm._v("增加")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-top": "1rem" },
          attrs: { data: _vm.parameterData, border: "" }
        },
        [
          _vm.show
            ? _c("el-table-column", { attrs: { prop: "id", label: "id" } })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "editionName", label: "版本名称" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "editionDesc", label: "版本说明" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.jurisdiction(scope.row)
                          }
                        }
                      },
                      [_vm._v("权限")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.parameterEdit(scope.$index, scope.row)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.parameterDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        attrs: {
          "page-sizes": [10],
          "page-size": _vm.page.pageSize,
          layout: "total, sizes, prev, pager, next",
          total: _vm.page.totalRecords
        },
        on: {
          "size-change": _vm.sizeChange,
          "current-change": _vm.currentChange
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增版本",
            visible: _vm.addParameteForm,
            size: "tiny",
            "modal-append-to-body": false
          },
          on: { close: _vm.closeDialog }
        },
        [
          _c(
            "el-form",
            {
              ref: "addsForm",
              attrs: {
                id: "#addsForm",
                model: _vm.addsForm,
                "label-width": "150px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "版本名", prop: "editionName" } },
                [
                  _c("el-input", {
                    attrs: { "max-length": "10" },
                    model: {
                      value: _vm.addsForm.editionName,
                      callback: function($$v) {
                        _vm.$set(_vm.addsForm, "editionName", $$v)
                      },
                      expression: "addsForm.editionName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "版本说明", prop: "editionDesc" } },
                [
                  _c("el-input", {
                    attrs: { "max-length": "10" },
                    model: {
                      value: _vm.addsForm.editionDesc,
                      callback: function($$v) {
                        _vm.$set(_vm.addsForm, "editionDesc", $$v)
                      },
                      expression: "addsForm.editionDesc"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.studentAdd()
                        }
                      }
                    },
                    [_vm._v("确定")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.addParameteForm = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改版本",
            visible: _vm.editParameteForm,
            size: "tiny",
            "modal-append-to-body": false
          },
          on: { close: _vm.closeDialog }
        },
        [
          _c(
            "el-form",
            {
              ref: "editsForm",
              attrs: {
                id: "#editsForm",
                model: _vm.editsForm,
                "label-width": "150px"
              }
            },
            [
              _vm.value
                ? _c("el-input", {
                    model: {
                      value: _vm.editsForm.id,
                      callback: function($$v) {
                        _vm.$set(_vm.editsForm, "id", $$v)
                      },
                      expression: "editsForm.id"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "版本名", prop: "editionName" } },
                [
                  _c("el-input", {
                    attrs: { "max-length": "10" },
                    model: {
                      value: _vm.editsForm.editionName,
                      callback: function($$v) {
                        _vm.$set(_vm.editsForm, "editionName", $$v)
                      },
                      expression: "editsForm.editionName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "版本名", prop: "editionDesc" } },
                [
                  _c("el-input", {
                    attrs: { "max-length": "10" },
                    model: {
                      value: _vm.editsForm.editionDesc,
                      callback: function($$v) {
                        _vm.$set(_vm.editsForm, "editionDesc", $$v)
                      },
                      expression: "editsForm.editionDesc"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.studentEdit()
                        }
                      }
                    },
                    [_vm._v("确定")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.editParameteForm = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "权限管理",
            visible: _vm.jurisdictionForm,
            size: "tiny",
            "modal-append-to-body": false
          },
          on: { close: _vm.closeDialog }
        },
        [
          _c("el-tree", {
            ref: "tree",
            attrs: {
              data: _vm.treeData,
              "show-checkbox": "",
              "node-key": "id",
              "default-checked-keys": _vm.treeSelected,
              "default-expand-all": true
            }
          }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "ujurisdictionForm",
              attrs: {
                id: "#ujurisdictionForm",
                model: _vm.ujurisdictionForm,
                "label-width": "150px"
              }
            },
            [
              _vm.value
                ? _c("el-input", {
                    model: {
                      value: _vm.ujurisdictionForm.id,
                      callback: function($$v) {
                        _vm.$set(_vm.ujurisdictionForm, "id", $$v)
                      },
                      expression: "ujurisdictionForm.id"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.value
                ? _c("el-input", {
                    model: {
                      value: _vm.ujurisdictionForm.jurisdictions,
                      callback: function($$v) {
                        _vm.$set(_vm.ujurisdictionForm, "jurisdictions", $$v)
                      },
                      expression: "ujurisdictionForm.jurisdictions"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.jurisdictionAdd()
                        }
                      }
                    },
                    [_vm._v("确定")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.jurisdictionForm = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fae4d52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fae4d52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/editionList.vue
// module id = null
// module chunks = 